<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('dashboard_widgets.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openDashboardWidgetForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetDashboardWidgets(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="dashboard_widgets" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openDashboardWidgetForm(props.item)">
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.name_alias }}</td>
                                <td>{{ props.item.column_span }}</td>
                                <td>{{ props.item.permission }}</td>
                                <td>{{ props.item.active }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="dashboard_widgets"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="dashboard_widget_dialog">
                <v-card>
                    <v-form ref="form_dashboard_widget">
                        <v-card-title>
                            <span class="headline">{{ dashboard_widget.widget_id ? $t("lang.edit_dashboard_widget") : $t("lang.add_dashboard_widget") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeDashboardWidgetDialog"
                                :dialog-status="dashboard_widget_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="dashboard_widget_dialog"
                                            v-model="dashboard_widget.name"
                                            :label="`${$t('lang.name')} *`"
                                            :counter="showCounter(dashboard_widget.name, 'dashboard_widgets.name')"
                                            :rules="ifValid('dashboard_widgets.name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="dashboard_widget.name_alias"
                                            :label="$t('lang.name_alias')"
                                            :counter="showCounter(dashboard_widget.name_alias, 'dashboard_widgets.name_alias')"
                                            :rules="ifValid('dashboard_widgets.name_alias')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="dashboard_widget.column_span"
                                            :label="`${$t('lang.column_span')} *`"
                                            :counter="showCounter(dashboard_widget.column_span, 'dashboard_widgets.column_span')"
                                            :rules="ifValid('dashboard_widgets.column_span')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="dashboard_widget.permission"
                                            :label="$t('lang.permission')"
                                            :counter="showCounter(dashboard_widget.permission, 'dashboard_widgets.permission')"
                                            :rules="ifValid('dashboard_widgets.permission')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="dashboard_widget.active"
                                            :label="`${$t('lang.active')} *`"
                                            :rules="ifValid('dashboard_widgets.active')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="dashboard_widget.widget_id" color="error" @mouseup.left="$refs.delete_dashboard_widgets.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeDashboardWidgetDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveDashboardWidgets">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_dashboard_widgets"
                :heading="$t('lang.delete_dashboard_widget')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteDashboardWidgets(dashboard_widget.widget_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openDashboardWidgetForm" },
                { title: this.$t("lang.refresh"), action: "dbGetDashboardWidgets", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.name"), sortable: false, width: "20%" },
                { text: this.$t("lang.name_alias"), sortable: false, width: "20%" },
                { text: this.$t("lang.column_span"), sortable: false, width: "20%" },
                { text: this.$t("lang.permission"), sortable: false, width: "20%" },
                { text: this.$t("lang.active"), sortable: false, width: "20%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            dashboard_widget: {},
            filter: {
                search: "",
                status: "1",
            },
            dashboard_widget_dialog: false,
            dbGetDashboardWidgets: _.debounce(this.getDashboardWidgets, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchDashboardWidgets", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.dashboard_widgets) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchDashboardWidgets({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.dashboard_widgets) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.dashboard_widgets.dashboard_widgets_filter,
            page: (state) => state.dashboard_widgets.page,
            rules_dashboard_widgets: (state) => state.dashboard_widgets.rules_dashboard_widgets,
            dashboard_widget_status_options: (state) => state.settings.dashboard_widget_status_options,
            dashboard_widgets: (state) => state.dashboard_widgets.dashboard_widgets,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDashboardWidgets", "saveDashboardWidget", "deleteDashboardWidget"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openDashboardWidgetForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_dashboard_widget) item ? this.$refs.form_dashboard_widget.resetValidation() : this.$refs.form_dashboard_widget.reset();

                    this.$nextTick(() => {
                        this.dashboard_widget = item != null ? this.assignObj2(item, this.rules_dashboard_widgets) : {};
                        this.dashboard_widget_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "dashboard_widget", params: { id: item.widget_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_dashboard_widget) item ? this.$refs.form_dashboard_widget.resetValidation() : this.$refs.form_dashboard_widget.reset();
                    this.dashboard_widget_dialog = true;
                } else {
                    this.$router.push({ name: "dashboard_widget" });
                }
            }
        },
        saveDashboardWidgets() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_dashboard_widget")) {
                    let body = this.prepForm(this.dashboard_widget, this.rules_dashboard_widgets);

                    this.saveDashboardWidget({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getDashboardWidgets();
                                this.closeDashboardWidgetDialog();
                            } else {
                                this.$router.push({ name: "dashboard_widget", params: { id: data.widget_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteDashboardWidgets(id = null) {
            this.deleteDashboardWidget({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getDashboardWidgets();
                    this.closeDashboardWidgetDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeDashboardWidgetDialog() {
            this.dashboard_widget_dialog = false;
            this.$refs.delete_dashboard_widgets.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getDashboardWidgets(pg_refresh = false) {
            this.startLoader();

            this.fetchDashboardWidgets({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.dashboard_widget_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
